import React, { MouseEvent } from 'react'

import getLabels from '../../utils/getLabels'

import styles from './NewBookingCSVUpload.module.scss'

export interface NewBookingCSVUploadPropsInterface {
  openCSVUpload: (event: MouseEvent<HTMLButtonElement>) => any
  isDisabled: boolean
}

export default ({
  isDisabled,
  openCSVUpload,
}: NewBookingCSVUploadPropsInterface) => (
  <button
    type="button"
    className={styles['trigger']}
    data-element="open-csv-upload"
    onClick={openCSVUpload}
    disabled={isDisabled}
  >
    {getLabels('csv_open_upload')}
  </button>
)
